import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  GetAllStudentsSelectOptionsUseCaseInterface,
  HandleReportsAnalyticalActivitiesByStudent,
} from 'domain/usecases';

interface IReportsAnalyticalActivitiesByStudent {
  data: HandleReportsAnalyticalActivitiesByStudent.Result;
  studentsSelectOptions: GetAllStudentsSelectOptionsUseCaseInterface.Result;
}

interface IPayloadData
  extends PayloadAction<HandleReportsAnalyticalActivitiesByStudent.Result> {}

interface IPayloadStudentsSelectOptions
  extends PayloadAction<GetAllStudentsSelectOptionsUseCaseInterface.Result> {}

const initialState: IReportsAnalyticalActivitiesByStudent = {
  data: null,
  studentsSelectOptions: [],
};

export const ReportsAnalyticalActivitiesByStudentSlice = createSlice({
  name: 'reports-analytical-activities-by-student',
  initialState,
  reducers: {
    loadReportsAnalyticalActivities: (state, action: IPayloadData) => {
      state.data = action.payload;
    },
    clearReportsAnalyticalActivities: (state) => {
      state.data = null;
    },
    loadStudentsSelectOptions: (
      state,
      action: IPayloadStudentsSelectOptions,
    ) => {
      state.studentsSelectOptions = action.payload;
    },
    clearStudentsSelectOptions: (state) => {
      state.studentsSelectOptions = [];
    },
  },
});

export const {
  loadReportsAnalyticalActivities,
  clearReportsAnalyticalActivities,
  loadStudentsSelectOptions,
  clearStudentsSelectOptions,
} = ReportsAnalyticalActivitiesByStudentSlice.actions;

export default ReportsAnalyticalActivitiesByStudentSlice.reducer;
